import { render, staticRenderFns } from "./recipes.vue?vue&type=template&id=0e7f5664"
import script from "./recipes.vue?vue&type=script&lang=js"
export * from "./recipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports